export default __webpack_public_path__ + "static/media/fad-AR.f4a1604c.svg";